const ReastartIcon = ({ width, height, color }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 13 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1357_297)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M0.583215 7.54167C0.867438 7.54167 1.09328 7.2951 1.09328 7C1.09328 4.98907 1.55803 3.68182 2.30319 2.87456C3.0404 2.07591 4.22223 1.58333 6.0498 1.58333C7.8774 1.58333 9.0592 2.07591 9.79641 2.87456C10.1571 3.26531 10.4521 3.77321 10.6605 4.42135C10.7375 4.66079 10.9467 4.83333 11.1899 4.83333C11.5283 4.83333 11.7819 4.50745 11.6798 4.17245C10.9331 1.72415 9.05643 0.5 6.0498 0.5C2.0498 0.5 0.0498047 2.66667 0.0498047 7C0.0498047 7.00796 0.0498114 7.01592 0.0498249 7.02383C0.0503164 7.31341 0.280688 7.54167 0.559612 7.54167H0.583215ZM1.43912 9.57866C1.36214 9.33919 1.15289 9.16667 0.909751 9.16667C0.571279 9.16667 0.317674 9.49253 0.419843 9.82755C1.16651 12.2758 3.04317 13.5 6.0498 13.5C10.0498 13.5 12.0498 11.3333 12.0498 7C12.0498 6.99204 12.0498 6.98408 12.0498 6.97617C12.0493 6.68659 11.8189 6.45833 11.54 6.45833H11.5164C11.2322 6.45833 11.0063 6.7049 11.0063 7C11.0063 9.01094 10.5416 10.3182 9.79641 11.1254C9.0592 11.9241 7.8774 12.4167 6.0498 12.4167C4.22223 12.4167 3.0404 11.9241 2.30319 11.1254C1.9425 10.7347 1.64751 10.2268 1.43912 9.57866Z'
          fill={color ? color :'#00BA9F'}
        />
        <path
          d='M11.5279 1.04163V4.29163H8.39746'
          stroke={color ? color :'#00BA9F'}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M0.571778 12.9584L0.571777 9.70837H3.70221'
          stroke={color ? color :'#00BA9F'}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_1357_297'>
          <rect
            width='12'
            height='13'
            fill='white'
            transform='translate(0.0498047 0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ReastartIcon;
